var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"target":"_blank","href":_vm.link}},[_c('q-img',{staticClass:"social-icon",attrs:{"width":"24px","height":"24px"},domProps:{"innerHTML":_vm._s(_vm.iconSrc)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }